<template>
  <div class="account_menu" ref="button">
    <div
      class="topmenu_item top_menu_button"
      :class="{ account_menu_open: open }"
      @click="toggle()"
    >
      <div class="top_menu_item_content">
        <span class="inline_icon">
          <SmallIcon :icon="$icon.account" color="white" />
        </span>
      </div>
    </div>

    <Teleport to="body">
      <div
        v-if="open"
        class="account_menu_list"
        ref="list"
        :style="{ top: list_top + 'px', right: list_right + 'px' }"
      >
        <div class="account_menu_user" v-if="$app.session.current_user">
          <div>{{ $app.session.current_user.name }}</div>
          <div class="account_menu_email">{{ $app.session.current_user.email }}</div>
        </div>
        <a class="account_menu_entry" @click="show_user_info()">
          {{ $txt.user_info }}
        </a>
        <div class="account_menu_divider"></div>
        <a class="account_menu_entry" @click="sign_out()">
          {{ $txt.sign_out }}
        </a>
      </div>
    </Teleport>
  </div>
</template>

<script>
import router from '@/router';

export default {
  name: "AccountMenu",

  data() {
    return {
      open: false,
      list_top: 0,
      list_right: 0
    };
  },

  methods: {
    toggle() {
      if (this.open) {
        this.close();
        return;
      }

      const rect = this.$refs.button.getBoundingClientRect();
      this.list_top = rect.bottom;
      this.list_right = window.innerWidth - rect.right;
      this.open = true;
      document.addEventListener("mousedown", this.on_outside_click);
      document.addEventListener("keydown", this.on_key);
      window.addEventListener("resize", this.close);
    },

    close() {
      this.open = false;
      document.removeEventListener("mousedown", this.on_outside_click);
      document.removeEventListener("keydown", this.on_key);
      window.removeEventListener("resize", this.close);
    },

    on_outside_click(event) {
      if (this.$refs.button?.contains(event.target) || this.$refs.list?.contains(event.target))
        return;
      this.close();
    },

    on_key(event) {
      if (event.key == "Escape") this.close();
    },

    show_user_info() {
      this.close();
      // eslint-disable-next-line
      router.push({ name: "account" }).catch(err => {});
    },

    sign_out() {
      this.close();
      this.$appm.log_out();
    }
  },

  watch: {
    $route() {
      this.close();
    }
  },

  beforeUnmount() {
    this.close();
  }
};
</script>
